import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    units: [],
    unit: {},
    totalItems:0,

};

const getters = {
    index: state => unitId => state.units.findIndex(i => i.unitId === unitId)
};

const mutations = {
    setUnits: (state, r) => (state.units = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    add: (state, r) => state.units.unshift(r),
    delete: (state, index) => state.units.splice(index, 1),
    lock: (state, index) => state.units[index].status = status.locked,
    unlock: (state, index) => state.units[index].status = status.active,
    setUnit: (state, r) => (state.unit = r),
    edit: (state, { index, r }) => state.units.splice(index, 1, r),

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.units.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setUnits", response.data.units);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            startLoading()
            const response = await dataService.units.add(payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.unit);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.units.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.units.lock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.units.unlock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setUnit", {});
            console.log(id)
            startLoading()
            const response = await dataService.units.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setUnit", response.data.unit);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.units.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.unit);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            startLoading()
            const response = await dataService.units.edit(id, payload);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }


            const index = getters.index(id);
            console.log(index);
            console.log(response.data.unit );
            commit("edit", { index, r: response.data.unit });

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
